var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isInitialized)?_c('div',[_c('LoadingScreen',{attrs:{"caption":'Supply Demand Analysis...'}}),_c('SlideYDownTransition',[(_vm.isNotConfigured)?_c('NotConfigured'):_vm._e()],1)],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }